import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  static targets = ['input']

  clean () {
    this.inputTargets.forEach((input) => {
      input.value = input.value.trim()
    })
  }
}
